export default {
  /**
   * Set Teacher application approval list.
   *
   * @param state
   * @param items
   */
  setEmployeeAwayApplicationApprovalList(state, items) {
    console.log("Items: ", items);
    state.items = items;
  },

  /**
   * Pagination.
   *
   * @param state
   * @param pagination
   */
  setEmployeeAwayApplicationApprovalListPagination(state, pagination) {
    console.log("Pagination: ", pagination);
    state.pagination = pagination;
  },

  /**
   * Set current page.
   *
   * @param state
   * @param page
   */
  setEmployeeAwayApplicationApprovalListPage(state, page) {
    state.pagination.current_page = page;
  },
};
